import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Pencil, Settings, Calendar, BookOpen, Video } from "lucide-react";
import { useFeatureFlagEnabled } from 'posthog-js/react'
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";

export const SidebarNavigation = () => {
  const location = useLocation();
  const showVideosPage = useFeatureFlagEnabled('show-linkpilot-videos')
  const showArticlesPage = useFeatureFlagEnabled('show-linkpilot-articles')

const navigationItems = [
  {
    title: "Posts",
    url: "/",
    icon: Pencil,
  },
  ...(showArticlesPage ? [{
    title: "Articles",
    url: "/articles",
    icon: BookOpen,
  }] : []),
  ...(showVideosPage ? [{
    title: "Videos",
    url: "/videos",
    icon: Video,
  }] : []),
  {
    title: "Calendar",
    url: "/calendar",
    icon: Calendar,
  },
  {
    title: "Settings",
    url: "/settings",
    icon: Settings,
  },
];

  return (
    <SidebarMenu className="font-montserrat list-none space-y-3">
      {navigationItems.map((item) => (
        <SidebarMenuItem key={item.title}>
          <SidebarMenuButton
            asChild
            isActive={location.pathname === item.url}
            tooltip={item.title}
            className={`
              transition-all duration-200
              ${location.pathname === item.url 
                ? "font-bold bg-white shadow-md text-primary" 
                : "font-normal hover:bg-gray-50"
              }
            `}
          >
            <Link to={item.url} className="flex items-center gap-3 px-4 py-2 rounded-lg">
              <item.icon className={`h-4 w-4 ${location.pathname === item.url ? "text-primary" : "text-gray-600"}`} />
              <span>{item.title}</span>
            </Link>
          </SidebarMenuButton>
        </SidebarMenuItem>
      ))}
    </SidebarMenu>
  );
};